import React from 'react';

// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Components
import MeetingModeIntroModalBody from '../MeetingModeIntroModalBody/MeetingModeIntroModalBody';

export const FirstTimeMeetingModeIntroData = {
  slides: [
    {
      slug: 'welcome-meeting-mode-slide',
      title: 'Welcome to Meeting Mode',
      imageBgColor: Colors.purple[25],
      image: Illustrations.three_people_at_table_purple_bg,
      description: `Stay in sync and organized during a meeting with this guided experience.`,
      nextBtnLabel: 'Got it',
      footer: <MeetingModeIntroModalBody version="first-time" />,
    },
  ],
} as NewFeatureCarouselModalType;
